import { render, staticRenderFns } from "./TambahProdukKompack.vue?vue&type=template&id=3a8c0e78&scoped=true&"
import script from "./TambahProdukKompack.vue?vue&type=script&lang=js&"
export * from "./TambahProdukKompack.vue?vue&type=script&lang=js&"
import style0 from "./TambahProdukKompack.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TambahProdukKompack.vue?vue&type=style&index=1&id=3a8c0e78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c0e78",
  null
  
)

export default component.exports